import ExtrasFilterAdvancedFilterLabel from './ExtrasFilterAdvancedFilterLabel';

export default ExtrasFilterAdvancedFilterLabel;
export { ExtrasFilterAdvancedFilterLabel };
